var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlatTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1135,
    height: 490,
    viewBox: "0 0 1135 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2264_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M896.53 487.2C855.43 487.2 822 453.77 822 412.67C822 371.57 855.43 338.14 896.53 338.14C937.63 338.14 971.06 371.57 971.06 412.67C971.06 453.77 937.63 487.2 896.53 487.2ZM896.53 363.14C869.22 363.14 847 385.36 847 412.67C847 439.98 869.22 462.2 896.53 462.2C923.84 462.2 946.06 439.98 946.06 412.67C946.06 385.36 923.84 363.14 896.53 363.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.82 489.46C168.72 489.46 135.29 456.03 135.29 414.93C135.29 373.83 168.72 340.4 209.82 340.4C250.92 340.4 284.35 373.83 284.35 414.93C284.35 456.03 250.92 489.46 209.82 489.46ZM209.82 365.4C182.51 365.4 160.29 387.62 160.29 414.93C160.29 442.24 182.51 464.46 209.82 464.46C237.13 464.46 259.35 442.24 259.35 414.93C259.35 387.62 237.13 365.4 209.82 365.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.14 412.08L470.73 414.17V370.02H292.92C292.92 370.02 278.08 329.43 205.7 329.43C151.09 329.43 127.81 390.32 127.81 390.32L50.47 363.99L0 362.89V323.85H757.36V0H785.99V334.74H832.39L795.15 412.08H795.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.05 350.64L1121.24 238.78C1121.24 238.78 1077.91 55.9 1027.86 55.9H802.86C791.76 54.31 793.86 325.9 793.86 325.9C793.86 325.9 836.5 326.46 896.54 325.99C946.61 325.6 984.36 363.4 984.36 399.52L1133.68 399.4L1134.21 350.63H1116.05V350.64ZM1074.09 230.32C1071.13 235.53 929.71 202.67 895.36 180.92C861.01 159.17 856.85 82.9 856.85 82.9H1018.85C1018.85 82.9 1079.66 220.5 1074.08 230.32H1074.09Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2264_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1134.21,
    height: 489.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatTruck);
export default __webpack_public_path__ + "static/media/FlatTruck.88b371056d4c12c75193853ecd2462fd.svg";
export { ForwardRef as ReactComponent };